export default __webpack_public_path__ + "static/media/sponsor-medina-bg.0ce98de5.png";